import { RG68_24 } from "./RG68_24"

export const RG68_23 = {
    "selectedValueColumn": "DistrictGroupAgentCode",
    "selectedTitle": "Customer Group",
    "visual": [
        {
            "columns": 12,
            "rows": 2,
            "visual": {
                "id": 1,
                "type": "advancedTable",
                "colorTheme": 'colorTheme1',
                "title": "Customer Group Growth",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Customer Group',
                                "columnName": 'CustomerGroup',
                                "width": '170px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                            },
                            {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": "TerritoryName",
                        "endpoint": "RG68.23",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "DistrictGroupAgentCode", "value": "" },
                            { "key": "ConfigTypeCode", "value": "" },
                            { "key": "RegionCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": RG68_24
                        }
                    }
                }
            }
        }
    ]
}